function getDateQuarter(date) {
  return Math.floor(date.getMonth() / 3 + 1);
}

export function getDataName(date, period) {
  switch (period.filter) {
    case "hour":
      return `${date.toLocaleString("en-us", { hour: "numeric" })}`;
    case "day":
      return `${date.toLocaleString("en-us", { day: "numeric", month: "numeric" })}`;
    case "month":
      return `${date.toLocaleString("en-us", { month: "short" })}`;
    case "quarter":
      return `Q${getDateQuarter(date)}`;
    case "year":
      return `${date.toLocaleString("en-us", { year: "numeric" })}`;
    default:
      return `${date.toLocaleString("en-us")}`;
  }
}
